import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const vivaSuiteNavLoader = () => import(/* webpackChunkName: "4-feat-viva-suite-nav" */ './VivaSuiteNav');
export default lazyLoadOnRender({ loader: vivaSuiteNavLoader });
